import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faAddressBook as fasAddressBook,
  faBackward,
  faBan as fasBan,
  faBars,
  faBarcode,
  faBolt,
  faBoxesAlt as fasBoxesAlt,
  faBriefcase as fasBriefcase,
  faBullhorn,
  faCalendarAlt as fasCalendarAlt,
  faCalculator,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCheckCircle as fasCheckCircle,
  faCheckSquare,
  faChevronCircleLeft,
  faChevronCircleRight,
  faClipboardCheck,
  faClipboardListCheck,
  faCog,
  faCogs,
  faDolly,
  faDotCircle,
  faEdit as fasEdit,
  faExclamationCircle as fasExclamationCircle,
  faExclamationTriangle as fasExclamationTriangle,
  faFileCheck,
  faFileContract,
  faFileCsv as fasFileCsv,
  faFlag,
  faForward,
  faHandHoldingBox,
  faHandHoldingUsd,
  faHome,
  faIndustryAlt,
  faLink,
  faLockAlt,
  faLockOpenAlt,
  faMapMarkerAlt,
  faMedkit,
  faMinus,
  faParking,
  faPlus,
  faPlusCircle as fasPlusCircle,
  faReceipt,
  faRulerTriangle,
  faSearch,
  faShare as fasShare,
  faShieldCheck,
  faSitemap,
  faSpinner,
  faStar as fasStar,
  faTh,
  faTools,
  faText,
  faUsers,
  faUserCheck,
  faUserCircle,
  faUsersClass,
  faUserGraduate,
  faUserLock,
  faUserTie,
  faUserTimes,
  faWarehouse as fasWarehouse,
  faWrench
} from '@fortawesome/pro-solid-svg-icons'

import {
  faAddressBook as farAddressBook,
  faAddressCard,
  faAlignLeft,
  faAngry,
  faAngleRight,
  faArrowAltSquareUp,
  faArrowAltToBottom, // replace with ArrowToBottom?
  faArrowToBottom,
  faArrowLeft,  // replaced by Chevron left?
  faArrowRight,
  faBalanceScale,
  faBan as farBan,
  faBallotCheck as farBallotCheck,
  faBell,
  faBoxesAlt as farBoxesAlt,
  faBoot,
  faBriefcase as farBriefcase,
  faCalendarAlt as farCalendarAlt,
  faCalendarEdit,
  faCalendarWeek,
  faCaretCircleDown,
  faCopy,
  faChartLine,
  faCheck,
  faCheckCircle as farCheckCircle, // unused
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCloudUpload,
  faCreditCard,
  faDownload,
  faDraftingCompass,
  faEdit as farEdit,
  faEllipsisV,
  faEnvelope,
  faExchange,
  faExclamation,
  faExclamationCircle as farExclamationCircle,
  faExclamationTriangle as farExclamationTriangle,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileInvoiceDollar,
  faFilePdf,
  faFileSignature,
  faFileCsv as farFileCsv,
  faFilter,
  faGarage,
  faGlobe,
  faHistory,
  faHandPointer,
  faImage,
  faInfoCircle,
  faInfoSquare,
  faInventory,
  faInboxIn,
  faMicrochip,
  faMinusCircle,
  faMoneyCheckAlt,
  faMoneyCheckEditAlt,
  faMoneyCheckEdit,
  faNetworkWired,
  faNewspaper,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faPen,
  faPlusCircle as farPlusCircle,
  faPlusHexagon,
  faQuestionCircle,
  faRulerCombined,
  faRulerHorizontal,
  faRulerVertical,
  faSave,
  faShare as farShare,
  faShoppingCart,
  faSignature,
  faSlidersH,
  faSquare,
  faStar as farStar,
  faStickyNote,
  faSync,
  faTag,
  faTicket,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUmbrellaBeach,
  faUndoAlt,
  faUser,
  faUserHeadset,
  faUserHardHat,
  faWarehouse as farWarehouse,
  faWarehouseAlt,
  faWind
} from '@fortawesome/pro-regular-svg-icons'

import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

library.add(
  farAddressBook,
  fasAddressBook,
  faAddressCard,
  faAlignLeft,
  faAngry,
  faAngleRight,
  faArrowAltSquareUp,
  faArrowAltToBottom,
  faArrowLeft,
  faArrowRight,
  faArrowToBottom,
  faBackward,
  faBalanceScale,
  farBallotCheck,
  farBan,
  fasBan,
  faBars,
  faBarcode,
  faBell,
  faBolt,
  faBoot,
  farBoxesAlt,
  fasBoxesAlt,
  farBriefcase,
  fasBriefcase,
  faBullhorn,
  faCalculator,
  farCalendarAlt,
  fasCalendarAlt,
  faCalendarEdit,
  faCalendarWeek,
  faCaretCircleDown,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faChartLine,
  faCheck,
  farCheckCircle,
  fasCheckCircle,
  faCheckSquare,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faClipboardCheck,
  faClipboardListCheck,
  faCloudUpload,
  faCog,
  faCogs,
  faCopy,
  faCreditCard,
  faDotCircle,
  faDolly,
  faDownload,
  faDraftingCompass,
  farEdit,
  fasEdit,
  faEllipsisV,
  faEnvelope,
  faExchange,
  faFilter,
  faExclamation,
  farExclamationCircle,
  fasExclamationCircle,
  farExclamationTriangle,
  fasExclamationTriangle,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileCheck,
  faFileContract,
  fasFileCsv,
  farFileCsv,
  faFileInvoiceDollar,
  faFilePdf,
  faFileSignature,
  faFlag,
  faForward,
  faGarage,
  faGlobe,
  faHandHoldingBox,
  faHandHoldingUsd,
  faHandPointer,
  faHistory,
  faHome,
  faIndustryAlt,
  faInfoCircle,
  faInfoSquare,
  faImage,
  faInventory,
  faInboxIn,
  faLink,
  faLockAlt,
  faLockOpenAlt,
  faMapMarkerAlt,
  faMedkit,
  faMicrochip,
  faMinus,
  faMinusCircle,
  faMoneyCheckAlt,
  faMoneyCheckEditAlt,
  faMoneyCheckEdit,
  faNetworkWired,
  faNewspaper,
  faPalette,
  faParking,
  faPaperPlane,
  faPaperclip,
  faPen,
  faPlus,
  farPlusCircle,
  fasPlusCircle,
  faPlusHexagon,
  faQuestionCircle,
  faReceipt,
  faRulerCombined,
  faRulerHorizontal,
  faRulerVertical,
  faRulerTriangle,
  faSave,
  faSearch,
  farShare,
  fasShare,
  faShieldCheck,
  faShoppingCart,
  faSignature,
  faSitemap,
  faSlidersH,
  faSquare,
  faSpinner,
  farStar,
  fasStar,
  faStickyNote,
  faSync,
  faTag,
  faText,
  faTicket,
  faTimes,
  faTimesCircle,
  faTh,
  faTools,
  faTrashAlt,
  faUmbrellaBeach,
  faUndoAlt,
  faUser,
  faUserCheck,
  faUserCircle,
  faUsersClass,
  faUserHeadset,
  faUserHardHat,
  faUserLock,
  faUsers,
  faUserTie,
  faUserGraduate,
  faUserTimes,
  farWarehouse,
  fasWarehouse,
  faWarehouseAlt,
  faWind,
  faWrench
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)